import { OpspbRefundOverride } from '@itsrever/rever-api'

// An unedited prefill can be stale (e.g. external-refund reconciliation commits
// on the process ledger), so only an amount the reviewer actually changed may
// override the backend's own refund arithmetic.
export function buildRefundOverride(
  amountEdited: boolean,
  reason: string,
  amount: string,
  currency: string
): OpspbRefundOverride {
  if (!amountEdited) {
    return {}
  }
  return {
    requested: true,
    reason,
    amount: {
      amount,
      currency_code: currency
    }
  }
}
